/* Reusable KPI card for the RoyAI dashboard. */
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function KpiCard({ label, value, delta, icon: Icon, accent = "#D4AF37", testId }) {
  const positive = delta > 0;
  return (
    <div
      data-testid={testId}
      className="relative border border-white/5 bg-[#0c0c0c] px-5 py-6 group hover:border-amber-500/30 transition-colors"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-neutral-400">
          {label}
        </div>
        {Icon && (
          <div
            className="w-9 h-9 rounded-full border flex items-center justify-center transition-transform group-hover:scale-110"
            style={{ borderColor: `${accent}55`, background: `${accent}12` }}
          >
            <Icon size={16} style={{ color: accent }} strokeWidth={1.6} />
          </div>
        )}
      </div>
      <div className="font-display text-3xl lg:text-4xl font-medium text-white leading-none">
        {value}
      </div>
      {delta !== undefined && delta !== null && (
        <div
          className={`mt-3 flex items-center gap-1 text-xs font-mono-tech ${
            positive ? "text-emerald-400" : "text-rose-400"
          }`}
        >
          {positive ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
          {Math.abs(delta).toFixed(1)}% <span className="text-neutral-500">vs last quarter</span>
        </div>
      )}
    </div>
  );
}
